import { Badge, CircleCrossIcon, DisabledIcon, DurationIcon, Tooltip } from "@xola/ui-kit";
import React from "react";
import { PurchaseItem } from "types";
import { PurchaseItemStatus } from "../../models/PurchaseItem";

/**
 * Show the right icon depending on the status of the purchase item
 */
export const StatusIcon = ({ item }: { item: PurchaseItem }) => {
    if (!statusMap[item.status]) {
        return null;
    }

    const status = statusMap[item.status];
    return (
        <Tooltip content={status.title}>
            <div className="tracking-tightest inline-flex items-center">
                {statusForTextDisplay.has(item.status) ? (
                    <Badge color={status.color} icon={React.cloneElement(status.icon, { size: "small" })}>
                        {status.title}
                    </Badge>
                ) : (
                    status.icon
                )}
            </div>
        </Tooltip>
    );
};

const statusForTextDisplay = new Set([
    PurchaseItemStatus.CANCELED,
    PurchaseItemStatus.DECLINED,
    PurchaseItemStatus.PENDING_ACCEPT,
    PurchaseItemStatus.PENDING_MINIMUM,
]);

const statusMap: any = {
    [PurchaseItemStatus.PENDING_ACCEPT]: {
        color: "warning",
        icon: <DurationIcon size="medium" className="text-yellow" />,
        title: "Pending",
    },
    [PurchaseItemStatus.PENDING_MINIMUM]: {
        color: "warning",
        icon: <DurationIcon size="medium" className="text-yellow" />,
        title: "Pending",
    },
    [PurchaseItemStatus.CANCELED]: {
        color: "danger",
        icon: <CircleCrossIcon size="medium" className="text-danger" />,
        title: "Canceled",
    },
    [PurchaseItemStatus.DECLINED]: {
        color: "danger",
        icon: <DisabledIcon size="medium" className="text-danger" />,
        title: "Declined",
    },
};
